import { Helmet } from "react-helmet";


const MetaDecorator = ({ title, description,imageUrl,showBrand, schemaMarkup  }) => {
  const path = window.location.pathname;
const normalizedPath = path.endsWith("/") ? path : path + "/";
// console.log(normalizedPath);
const schemaMarkupJson = schemaMarkup ? JSON.stringify(schemaMarkup) : null;

  return (
  <Helmet>
    <title>{`${title}${showBrand?" - Metatech Official":''}`}</title>
    <meta property="og:title" content={title} />
    <meta name="description" content={description} />
    <meta property="og:description" content={description} />
    {/* <meta property="og:image" content={imageUrl} /> */}
    <link rel="canonical" href={"https://metatech-official.com"+ normalizedPath} />

    <meta
      property="og:url"
      content={"https://metatech-official.com"+ normalizedPath}
    />
    <meta name="twitter:card" content={title} />
    <meta name="twitter:image:alt" content={title} />
    {schemaMarkupJson && (
      <script type="application/ld+json">
        {schemaMarkupJson}
      </script>
    )}
  </Helmet>
)};


export default MetaDecorator
